import { data, user } from 'services';
import { StatusSetForm } from 'libs/forms';

export const getTableParams = (inList = true, t) => {
  const setRight = user.haveRight('clients.bulk');
  const setActions =
    inList && setRight
      ? [
          {
            title: 'Статус',
            key: 'status',
            form: StatusSetForm,
            dict: 'clients.status',
            // dictExclude: ['blocked_by_client'],
            simple: false,
            method: 'clients.bulk_change_status',
            idsParam: 'ids',
          },
        ]
      : [];

  // get row class
  const getRowClass = (row) => {
    let out = '';
    out += ' ' + row.status;
    return out;
  };

  const getContactName = (val) => {
    return val ? val.name : '';
  };

  const getPhoneNumber = (val) => {
    return val ? '+' + val.tel_num : '';
  };

  const getFields = () => {
    const fields = [
      { name: 'name', title: t('form.Клиент'), sortField: 'name' },
      { name: 'type', title: t('dict_filter.Тип'), sortField: 'type', width: 100, render: (val) => data.getDictValue('clients.type', val) },
      { name: 'status', title: t('grid.Статус'), sortField: 'status', width: 115, render: (val) => data.getDictValue('clients.status', val) },
      { name: 'contact', title: t('grid.Контактное лицо'), width: 215, render: (val) => getContactName(val) },
      { name: 'tel_num', title: t('grid.Телефон'), width: 140, render: (val) => getPhoneNumber(val) },
    ];

    return fields;
  };

  return { getFields, getRowClass, setActions };
};
